define('view/controller/booking/result/BookingResultEmptyView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    return LayoutView.extend({

        template: '#booking_result_empty'

    });

});
